import api from "../../../api/axios";

export const fetchPropertySummary = (propertyId, { signal } = {}) =>
  api
    .get(`/realty/properties/${propertyId}/`, { signal })
    .then((res) => res.data);
